import { Field } from "formik";
import React from "react";
import { useRuleFieldSchema } from "containers/Settings/RuleBooks/Schema/schemaContext";
import {
  getRelationByPath,
  getType,
} from "containers/Settings/RuleBooks/Schema/schema";
import { withNamespace } from "components/Form/FormikControls";
import { FieldType } from "containers/Settings/RuleBooks/constants";
import { useFieldState } from "hooks";
import { SchemaFieldDataSource } from "./SchemaFieldDataSource";

export interface SumDataSourceField {
  source: "SUM";
  value: string;
  index: number | "";
  valueType: FieldValueType;
}

export interface SumDataSourceProps {
  namespace: string;

  // The list of paths from the criteria list to be displayed in the dropdown
  options: string[];

  // The minimum index in the options that can be selected
  allowFromIndex?: number;
}

export function SumDataSource(props: SumDataSourceProps) {
  const { allowFromIndex = null, namespace: ns, options = [] } = props;
  const [value, setValue] = useFieldState(ns);

  const schema = useRuleFieldSchema();

  function onChangeIndex({ target: selectEl }) {
    const { selectedIndex } = selectEl;

    const selectedValue =
      selectedIndex > -1 ? selectEl.options[selectedIndex].value : "";

    const updatedField = {
      source: "SUM",
      value: "",
      criteria_output_index: selectedValue,
      valueType: getType(schema, selectedValue),
    };

    setValue(updatedField);
  }

  const areOptionsAvailable = Array.isArray(options) && options.length > 0;

  const selectedPath = options[value.criteria_output_index];

  return (
    <>
      <Field
        as="select"
        className="p-2"
        disabled={!areOptionsAvailable}
        name={withNamespace(ns, "criteria_output_index")}
        onChange={onChangeIndex}
        placeholder="Criteria number"
        required
      >
        <option value="" disabled>
          {areOptionsAvailable
            ? "Select a Criteria"
            : "No options are available"}
        </option>
        {options.map((option, index) => {
          const key = `${option}-${index}`;
          return (
            <option
              key={key}
              value={index}
              disabled={
                allowFromIndex !== null ? allowFromIndex <= index : false
              }
            >
              {getRelationByPath(schema, option)?.dataType.plural || option}{" "}
              (from criteria {index + 1})
            </option>
          );
        })}
      </Field>
      <span className="p-2"> by </span>
      <SchemaFieldDataSource
        dataTour="sum-data-source"
        namespace={ns}
        fieldType={FieldType.NUMERIC}
        fieldPath={selectedPath}
        schema={schema}
        showProperties
      />
    </>
  );
}
